/* eslint-disable jsx-a11y/label-has-associated-control */
// 🔩 Base
import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';

// 🇫🇷 i18n
import { LocalizedMessage } from 'intl/LocalizedComponents';
import { injectIntl } from 'react-intl';

// 🖼️ Assets
import AppIcon from 'components/icons/AppIcon';

// 🎨 Styles

const labelStyles = {
  fontSize: '15px',
  fontWeight: 'bold',
  whiteSpace: 'nowrap',
  textAlign: 'left',
  cursor: 'inherit',
};

const inputStyles = (inputWidth) => ({
  fontWeight: 'normal',
  fontFamily: 'Roboto',
  fontSize: '16px',
  color: 'black',
  border: 'none',
  width: inputWidth,
  outline: 'none',
  cursor: 'inherit',
  padding: '0px',
});

const DateTimeItem = ({
  name,
  intl,
  labelId,
  iconId,
  formattedDate,
  placeholderId,
  inputWidth,
  onClick,
}) => (
  <div
    className="d-flex"
    style={{
      flexGrow: '0',
      gap: '5px',
    }}
    role="button"
    tabIndex={0}
    onClick={onClick}
  >
    {iconId ? <AppIcon id={iconId} primary /> : null}
    <div className="d-flex flex-column">
      <label htmlFor={name} style={labelStyles} className="text-first-letter-capitalize">
        <LocalizedMessage id={labelId} />
      </label>
      <input
        id={name}
        name={name}
        type="text"
        style={inputStyles(inputWidth)}
        readOnly
        placeholder={intl.formatMessage({ id: placeholderId })}
        value={formattedDate}
      />
    </div>
  </div>
);

DateTimeItem.propTypes = {
  name: PropTypes.string.isRequired,
  formattedDate: PropTypes.string.isRequired,
  inputWidth: PropTypes.string,

  labelId: PropTypes.string.isRequired,
  placeholderId: PropTypes.string,
  iconId: PropTypes.string,

  intl: PropTypes.object.isRequired,

  onClick: PropTypes.func,
};

DateTimeItem.defaultProps = {
  iconId: null,
  placeholderId: '',
  inputWidth: 'auto',
  onClick: null,
};

module.exports = compose(
  injectIntl,
)(DateTimeItem);



// WEBPACK FOOTER //
// ./components/core/DateTimePicker2/components/DateTimeItem.js